var _excluded = ["onArrowUp", "onArrowDown", "onArrowRight", "onArrowLeft", "onEsc", "onEnter", "onSpace", "onKeyPress", "component", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef } from "react";
import _ from "underscore";
import PropTypes from "prop-types";

var KeyPressManager = function KeyPressManager(_ref) {
  var onArrowUp = _ref.onArrowUp,
      onArrowDown = _ref.onArrowDown,
      onArrowRight = _ref.onArrowRight,
      onArrowLeft = _ref.onArrowLeft,
      onEsc = _ref.onEsc,
      onEnter = _ref.onEnter,
      onSpace = _ref.onSpace,
      onKeyPress = _ref.onKeyPress,
      component = _ref.component,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var Component = component;
  var ref = useRef(null);

  var handleKeyPress = function handleKeyPress(e) {
    switch (e.key) {
      case "ArrowDown":
        if (onArrowDown) {
          e.preventDefault();
          onArrowDown(ref.current, e);
        }

        break;

      case "ArrowUp":
        if (onArrowUp) {
          e.preventDefault();
          onArrowUp(ref.current, e);
        }

        break;

      case "ArrowRight":
        if (onArrowRight) {
          e.preventDefault();
          onArrowRight(ref.current, e);
        }

        break;

      case "ArrowLeft":
        if (onArrowLeft) {
          e.preventDefault();
          onArrowLeft(ref.current, e);
        }

        break;

      case "Escape":
        if (onEsc) {
          e.preventDefault();
          onEsc(ref.current, e);
        }

        break;

      case "Enter":
        // If you're trying to preventing default on Enter
        // you're probably doing something non-accessible
        if (onEnter) {
          onEnter(ref.current, e);
        }

        break;

      case " ":
        if (onSpace) {
          e.preventDefault();
          onSpace(ref.current, e);
        }

        break;

      default:
        onKeyPress(ref.current, e);
        break;
    }
  };

  if (typeof children === "function") return children({
    onKeyDown: handleKeyPress,
    ref: ref
  });
  return /*#__PURE__*/React.createElement(Component, _extends({
    onKeyDown: handleKeyPress,
    ref: ref
  }, rest), children);
};

KeyPressManager.propTypes = {
  onArrowUp: PropTypes.func,
  onArrowDown: PropTypes.func,
  onArrowRight: PropTypes.func,
  onArrowLeft: PropTypes.func,
  onEsc: PropTypes.func,
  onEnter: PropTypes.func,
  onSpace: PropTypes.func,
  onKeyPress: PropTypes.func,
  component: PropTypes.any,
  children: PropTypes.any
};
KeyPressManager.defaultProps = {
  onKeyPress: _.noop,
  component: "div"
};
export default KeyPressManager;